module.exports = __webpack_public_path__ + "static/media/2021_2A3A3027.dd195e40.jpg";